import { getJson, requestVoid } from './client';
import type { BlockedUsersPageDto } from '../data/schemas/userBlock';

export type { BlockedUserDto, BlockedUsersPageDto } from '../data/schemas/userBlock';

/**
 * 사용자 차단. 성공 시 빈 success envelope 를 반환하므로 requestVoid 로 처리한다.
 * userId 는 64bit Snowflake — string 그대로 path 에 인코딩한다.
 */
export function blockUser(userId: string) {
  return requestVoid(`/api/v1/users/${encodeURIComponent(userId)}/block`, {
    method: 'POST',
  });
}

/** 차단 해제. 성공 시 빈 success envelope. */
export function unblockUser(userId: string) {
  return requestVoid(`/api/v1/users/${encodeURIComponent(userId)}/block`, {
    method: 'DELETE',
  });
}

/** 내가 차단한 사용자 목록 (offset 페이징). */
export function getBlockedUsers(params: { page?: number; size?: number } = {}) {
  const search = new URLSearchParams();
  search.set('page', String(params.page ?? 0));
  search.set('size', String(params.size ?? 20));
  return getJson<BlockedUsersPageDto>(`/api/v1/users/me/blocks?${search.toString()}`);
}
